import React, { FC } from 'react';
import Loader from 'components/Loaders/SupportPhoneNumbers';
import useConnect from './connect';
import {
  Container,
  Title,
  Subtitle,
  List,
  ListItem,
  Avatar,
  Name,
  PhoneNumber,
} from './styles';

const PhoneNumbers: FC = () => {
  const { isLoading, brandNumbers, integrationNumbers } = useConnect();

  return (
    <Container>
      <div>
        <Title>Brands</Title>
        <Subtitle>
          When you call the delivery platforms for any issues, please provide
          these brand’s phone numbers.
        </Subtitle>
      </div>
      <div>
        <Title>Platforms</Title>
        <Subtitle>
          For any live order issues, please call these phone numbers.
        </Subtitle>
      </div>

      {isLoading ? (
        <List>
          <Loader opacity={1} />
          <Loader opacity={0.75} />
          <Loader opacity={0.5} />
          <Loader opacity={0.25} />
          <Loader opacity={0} />
        </List>
      ) : (
        <List>
          {brandNumbers.map((brand) => (
            <ListItem key={brand.id}>
              <Avatar src={brand.image?.src} alt={brand.image?.alt} />
              <Name>{brand.name}</Name>
              <PhoneNumber>{brand.phoneNumber}</PhoneNumber>
            </ListItem>
          ))}
        </List>
      )}

      {isLoading ? (
        <List>
          <Loader opacity={1} />
          <Loader opacity={0.75} />
          <Loader opacity={0.5} />
          <Loader opacity={0.25} />
          <Loader opacity={0} />
        </List>
      ) : (
        <List>
          {integrationNumbers.map((integration) => (
            <ListItem key={integration.id}>
              <Avatar
                src={integration.image?.src}
                alt={integration.image?.alt}
              />
              <Name>{integration.name?.short}</Name>
              <PhoneNumber>{integration.phoneNumber}</PhoneNumber>
            </ListItem>
          ))}
        </List>
      )}
    </Container>
  );
};

export default PhoneNumbers;
